import React from "react"

// import Auth from "auth";
// import { API } from "API"
import { APIPost, APIGet } from "services/APIRequest"
import { arrayObject } from "ConvertKey"
import UrlServer from "configs/UrlServer"
import Configs from "services/ConfigHost"

import Lg from "language"

import Auth from "auth"
import { thaiBath } from "helpers/ConvertFormat"
import { ISOToDateYMDAndFullTime } from "helpers/ConvertDate"
import { ErrorsCallback, SuccessCallback, WarningCallback } from "alertService"

import { compose } from "recompose"
import { connect } from "react-redux"
import { listsUserFromImportUpdate, listsThemeSMSUpdate } from "store/actions"

import * as Alert from "alertService"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

// @material-ui/icons
import AddCircleIcon from "@material-ui/icons/AddCircle"
import EditIcon from "@material-ui/icons/Edit"
import FilterListIcon from "@material-ui/icons/FilterList"
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import VerticalAlignBottomIcon from '@material-ui/icons/VerticalAlignBottom';

// @material-ui/Dialog 
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

// core components 
import ReactTable from "react-table"
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import CustomInput from "components/CustomInput/CustomInput"
import Button from "components/CustomButtons/Button"
import Card from "components/Card/Card"
import CardBody from "components/Card/CardBody"
import CardIcon from "components/Card/CardIcon"
import CardHeader from "components/Card/CardHeader"
import Select from "components/CustomSelects/Select"
import FileConfigUploadSingle from "components/CustomUpload/FileConfigUploadSingle"
import Checkbox from '@material-ui/core/Checkbox';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Datetime from "react-datetime";

import { cardTitle } from "assets/jss/material-dashboard-pro-react"
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
const styles = {
  ...regularFormsStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  marginHR: {
    marginTop: "35px",
    marginBottom: "-5px"
  },
  mt4: {
    marginTop: "30px"
  },
  mb4: {
    marginBottom: "20px"
  }
}
class ProjectCreateAndEditManagement extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      status_switch_date_picker: true,
      dataList: null,

      _id: null,
      fileName: "",
      filePath: "",
      originalFileName: "",
      importName: "",
      importNameStatusIncurrect: false,
      sendDatetime: null,
      rowCurrentData: {},
      txtSMSMessage: "",

      selectedImportCondition: "c0",
      statusDialogOpen: false,
      listsThemeSMSRaw: []
    }
  }
  componentDidMount() {
    this.props.listsThemeSMSUpdate()
  }
  componentWillUpdate(nextProps, nextState) {
    if (nextProps.currentData && nextProps.currentData !== nextState.rowCurrentData) {
      this.setState({
        rowCurrentData: nextProps.currentData,
        _id: nextProps.currentData._id,
        description: nextProps.currentData.description,
      })
    } else if (nextProps.currentData === null && this.state._id !== null) {
      this.setState({
        rowCurrentData: {},
        _id: null,
        name: ""
      })
    } else if (nextProps.listsThemeSMS && nextProps.listsThemeSMS !== nextState.listsThemeSMSRaw) {
      this.setState({
        listsThemeSMSRaw: nextProps.listsThemeSMS,
      }, () => {
        Alert.LoadingClose()
      })
    }
  }
  handleChangeState = name => event => {
    this.setState({
      importNameStatusIncurrect: false,
      [name]: event.target.value
    })
  }
  handleDownloadExcelFile = () => {
    document.location = Configs.FILE_PATH + "sms_nespresso.xlsx"
  }

  renderListData = data => {
    return data.map((CData, key) => {
      return {
        id: (key + 1),
        mobile_number: CData.mobile_number,
        status_mobile_invalid: (CData.status_mobile_invalid ? "ผิด" : "ถูกรูปแบบ"),
        data_duplicate_count: CData.data_duplicate_count + "",
        message: CData.message,
        message_length: CData.message_length + "",
        message_lenguage: CData.message_lenguage + "",
        credit_per_msg: CData.credit_per_msg + "",
        send_sms_date: ISOToDateYMDAndFullTime(CData.send_sms_date),
        // userType:(
        //   <div className={this.props.classes.tableH}>
        //     <Badge color={"info"}>{dataUser.user_type_name}</Badge>
        //   </div>),  
      }
    })
  }
  callbackUploadedUrl = (filename, originalFileName) => {
    this.setState({
      fileName: filename,
      filePath: Configs.FILE_PATH + filename,
      originalFileName: originalFileName
    }, () => {
      Alert.LoadingClose()
    })
  }
  handleDateTimeChange = (name, date) => {
    const dateF = new Date(date).toISOString()
    this.setState({
      [name]: dateF
    })
  }
  handleState = (key, val) => {
    this.setState({
      [key]: val
    })
  }
  handleChangehCeckbox = e => {
    this.setState({ [e.target.name]: !this.state[e.target.name] })
  }
  handleChangeSelected = (event) => {
    this.setState({ selectedImportCondition: event.target.value });
  }
  newUpload = () => {
    Alert.QuestionCallback("คุณต้องการอัพโหลดไฟล์ใหม่ใช่หรือไม่?", "red", () => {
      this.setState({
        // _id : null,
        filePath: "",
        originalFileName: "",
        dataList: null
      });
    })
  }
  checkDupListImport(callback) {
    Alert.Loading(true)
    const dataToSend = {
    }
    APIPost(UrlServer.URL_POST_SMS_DATA_IMPORT_LIST, dataToSend, ({ datas }) => {
      Alert.LoadingClose()
      var is_dup = false
      datas.map((row, index) => {
        console.log(row._id, this.state.importName)
        if (row._id == this.state.importName) {
          is_dup = true
        }
      })
      callback(is_dup)
    })

  }
  handleSendToPreview = () => {
    this.checkDupListImport((is_dup) => {
      if (is_dup) {
        this.setState({ importNameStatusIncurrect: true }, () => {
          WarningCallback("ชื่อข้อมูลซ้ำกับในระบบ โปรดเปลี่ยนชื่อ")
        })
      } else {
        if (this.state.importName === "") {
          WarningCallback("ต้องการข้อมูล : ชื่อข้อมูล")
        } else if (this.state.filePath === "") {
          WarningCallback("ต้องการข้อมูล : ไฟล์ข้อมูล Excel")
        } else if (this.state.txtSMSMessage === "") {
          WarningCallback("ต้องการข้อมูล : ข้อความ SMS")
        } else {
          Alert.Loading(true)
          const dataToSend = {
            setting_id: this.state._id,
            filePath: this.state.filePath,
            fileName: this.state.fileName,
            importName: this.state.importName,
            sendDatetime: this.state.sendDatetime,
            txtSMSMessage: this.state.txtSMSMessage
          }
          APIPost(UrlServer.URL_POST_IMPORT_EXCEL_SMS_DATA_PREVIEW, dataToSend, (datas) => {
            const setting_id = datas.datas.length > 0 ? datas.datas[0].lead_setting_id : ""

            if (datas && datas.failedTelCount && datas.failedTelCount > 0) {
              WarningCallback(datas.message + " : " + this.state.importName + " : มีรายการที่เบอร์ไม่ครบ 10 ตัวเลข.", () => {
                this.setState({
                  _id: setting_id,
                  dataList: this.renderListData(datas.datas)
                }, () => {
                  Alert.LoadingClose()
                })
              })
            } else {
              SuccessCallback(datas.message + " : " + this.state.importName, null, () => {
                this.setState({
                  _id: setting_id,
                  dataList: this.renderListData(datas.datas)
                }, () => {
                  Alert.LoadingClose()
                })
              })
            }
          })
        }
      }
    })
  }
  handleApproveLead = () => {
    if (this.state.importName === "") {
      WarningCallback("ต้องการข้อมูล : ชื่อข้อมูล")
    } else {
      Alert.Loading(true)
      const dataToSend = {
        importName: this.state.importName,
      }
      APIPost(UrlServer.URL_POST_IMPORT_EXCEL_SMS_DATA_APPROVE, dataToSend, (datas) => {
        SuccessCallback(datas.message + " : " + this.state.importName, null, () => {
          window.location.reload()
        })
      })
    }
  }
  handleDialogClose = () => {
    this.setState({ statusDialogOpen: false })
  }
  handleListItemClickSMS = (data_sms) => {
    this.setState({
      txtSMSMessage: data_sms.txt_sms_message,
      statusDialogOpen: false
    })
  }
  render() {
    const { classes } = this.props
    return (
      <div className={"card-space"}>
        <GridContainer >
          <GridItem xs={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <CloudUploadIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  นำเข้าข้อมูล SMS ที่ต้องการส่ง
                </h4>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    <GridItem xs={12}>
                      <hr className="hr-s" />
                    </GridItem>
                    <GridItem xs={12}>
                      <h5>{Lg.ts("* เงื่อนไขของการจัดทำไฟล์ Excel เพื่อนำข้อมูลเข้า")}</h5>
                      <ol>
                        <li>{Lg.ts('ต้องเป็นไฟล์ ".xlsx" และ Sheet ต้องเป็น TAB แรกเท่านั้น')}</li>
                        <li>{Lg.ts('ระบบจะกรองเบอร์ซ้ำเพียงอย่างเดียว')}</li>
                        <li>{Lg.ts('ข้อมูลจะเริ่มจาก Row ที่ 7 ของไฟล์ Excel')}</li>
                        <li>{Lg.ts('เมื่อกดอัพโหลดไฟล์แล้วจะมีปุ่มให้ยกเลิกการอัพโหลดแล้วเลือกไฟล์ใหม่ ถ้าต้องการ หรือ กดปุ่ม "ประมวลผลไฟล์" เพื่อตรวจสอบข้อมูลก่อนที่จะนำเข้าระบบจริงๆ')}</li>
                        <li>{Lg.ts('รายการที่ตั้งเวลาส่งจะถูกยกเลิกเมื่อมีการกดส่งเองไปแล้ว')}</li>
                      </ol>
                      <br />
                      <h5>{Lg.ts("* เงื่อนไขการคิดเครดิตต่อข้อความ")}</h5>
                      <b>{Lg.ts("เมื่อข้อความเป็นภาษาไทยหรือมีภาษาไทยอยู่ในข้อความด้วย")}</b>
                      <ol>
                        <li>{Lg.ts("70 ตัวอักษรแรกคิดเป็น 1 เครดิต")}</li>
                        <li>{Lg.ts("ส่วนที่ 2 จะคิดทุก 67 ตัวอักษรคิดเป็น 1 เครดิต เป็นเศษนับ 1 เครดิต")}</li>
                        <li>{Lg.ts('ถ้ามีสัญลักษณ์พิเศษ  "|", "^", "{" , "}", "[", "~", "]" , "/" จะนับเป็น 2 อักษร')}</li>
                      </ol>
                      <b>{Lg.ts("เมื่อข้อความเป็นภาษาอังกฤษ")}</b>
                      <ol>
                        <li>{Lg.ts("160 ตัวอักษรแรกคิดเป็น 1 เครดิต")}</li>
                        <li>{Lg.ts("ส่วนที่ 2 จะคิดทุก 152 ตัวอักษรคิดเป็น 1 เครดิต เป็นเศษนับ 1 เครดิต")}</li>
                        <li>{Lg.ts('ถ้ามีสัญลักษณ์พิเศษ  "|", "^", "{" , "}", "[", "~", "]", "/" จะนับเป็น 2 อักษร')}</li>
                      </ol>
                    </GridItem>
                    <GridItem xs={12}>
                      <Button
                        round
                        color="info"
                        className={classes.mb4}
                        onClick={this.handleDownloadExcelFile}
                      >
                        <CloudDownloadIcon className={classes.icons} />
                        ดึงไฟล์ตัวอย่าง
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2} lg={2}>
                      <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                        ชื่อข้อมูล
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={10} lg={10}>
                      <CustomInput
                        error={(this.state.importName == "" || this.state.importNameStatusIncurrect) ? true : false}
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          disabled: this.state.dataList != null,
                          type: "text",
                          value: this.state.importName,
                          placeholder: "From the one 01-01-2020 : 1000 datas",
                          onChange: this.handleChangeState("importName")
                        }}
                        helpText={this.state.importName ? (this.state.importNameStatusIncurrect ? <span className="txt-c-r">ชื่อซ้ำกับที่เคยนำเข้า !</span> : "") : (<span className="txt-c-r">* จำเป็นต้องใส่</span>)}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2} lg={2}>
                      <FormLabel className={classes.labelHorizontal + " txt-c-b2 date-a22334"}>
                        วันที่ส่ง SMS
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={10} lg={10} className={"m-b-2"}>
                      <FormControl fullWidth>
                        {
                          this.state.status_switch_date_picker ?
                            <Datetime
                              timeFormat='HH:mm'
                              onChange={e => this.handleDateTimeChange("sendDatetime", e)}
                              inputProps={{
                                disabled: this.state.dataList != null,
                                readOnly: true,
                                placeholder: "กดเลือกวันที่ตรงนี้",
                              }}
                            />
                            : null
                        }
                      </FormControl>
                      <small className="txt-c-dorg2">{Lg.ts('(รูปแบบวันที่ เดือน/วัน/ปี ชั่วโมง:นาที) , ไม่จำเป็นต้องใส่วันที่ส่ง เพราะสามารถไปกดส่งได้ทันทีที่ Tab รายการนำเข้า')}</small>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2} lg={2}>
                      <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                        ข้อความ SMS
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={8}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.txtSMSMessage,
                          placeholder: Lg.ts("ข้อความ SMS"),
                          multiline: true,
                          rows: "4",
                          rowsMax: "8",
                          onChange: e => this.handleState("txtSMSMessage", e.target.value)
                        }}
                        helpText={(<span className="txt-c-b"> {Lg.ts("(ตัวอย่าง) สวัสดีคุณ<{first_name}> <{last_name}> คุณคือผู้โชคดี <{code_number}>")} </span>)}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2}>
                      <Button
                        fullWidth
                        className={this.props.classes.buttonTable}
                        size="sm"
                        round
                        onClick={() => this.setState({ statusDialogOpen: true })}
                        color="info"
                      >
                        <VerticalAlignBottomIcon /> Theme SMS
                      </Button>
                      <small className="txt-c-dorg">สามารถเลือก Theme SMS ที่เป็น Campaign ต่างๆ ได้ (กดปุ่ม)</small>
                    </GridItem>
                    {
                      (!this.state.filePath || this.state.filePath == "") ?
                        <GridItem xs={12}>
                          <FileConfigUploadSingle
                            IsFileSMS={true}
                            lockFileType=".xlsx"
                            FilePath={this.state.filePath}
                            CallbackUploadedUrl={this.callbackUploadedUrl}
                          />
                        </GridItem>
                        : (this.state.dataList == null) ?
                          <GridItem xs={12}>
                            <div>
                              <span className="img-fw-txt m-l-4 txt-c-bu can-click">{this.state.filePath ? "ชื่อไฟล์ที่อัพโหลด คือ " + this.state.originalFileName + " , ลิ้งค์ที่อยู่ไฟล์ที่อัพโหลดแล้ว คือ " + this.state.filePath : "ยังไม่มีการเลือกอัพไฟล์"}</span>
                              <Button
                                round
                                color="danger"
                                className={classes.mt4}
                                onClick={() => this.newUpload()}
                              >
                                <ClearAllIcon className={classes.icons} />
                                {Lg.ts('ต้องการอัพไฟล์ใหม')}่
                              </Button>
                            </div>
                            <Button
                              round
                              color="warning"
                              className={classes.mt4}
                              onClick={this.handleSendToPreview}
                            >
                              <FilterListIcon className={classes.icons} />
                              {Lg.ts('ประมวลผลไฟล')}์
                            </Button>
                            <span className="description-label">
                              {Lg.ts('กดปุ่มนี้เมื่อต้องการให้ระบบกรองข้อมูลออกมาแสดงก่อนบันทึกเข้าสู่การใช้งาน')}<br />
                              <FormHelperText>{Lg.ts('เวลาในการกรองข้อมูลขึ้นอยู่กันจะนวนข้อมูล')}</FormHelperText>
                            </span>
                          </GridItem>
                          :
                          <GridItem xs={12}>
                            <div>
                              <span className="img-fw-txt m-l-4 txt-c-bu can-click">{this.state.filePath ? "ชื่อไฟล์ที่อัพโหลด คือ " + this.state.originalFileName + " , ลิ้งค์ที่อยู่ไฟล์ที่อัพโหลดแล้ว คือ " + this.state.filePath : "ยังไม่มีการเลือกอัพไฟล์"}</span>
                              <Button
                                round
                                color="danger"
                                className={classes.mt4}
                                onClick={() => this.newUpload()}
                              >
                                <ClearAllIcon className={classes.icons} />
                                {Lg.ts('ต้องการอัพไฟล์ใหม่')}่
                              </Button>
                            </div>
                            <Button
                              round
                              color="success"
                              className={classes.mt4}
                              onClick={(e) => this.handleApproveLead()}
                            >
                              <CheckCircleIcon className={classes.icons} />
                              {Lg.ts('ยืนยันรายการทั้งหมดที่แสดง')}
                            </Button>
                          </GridItem>
                    }
                    {
                      this.state.dataList ?
                        <GridItem xs={12}>
                          <ReactTable
                            className="-striped -highlight table-scroll"
                            data={this.state.dataList}
                            filterable
                            columns={[
                              {
                                Header: Lg.ts('No.'),
                                accessor: "id",
                                width: 70
                              },
                              {
                                Header: Lg.ts('เบอร์มือถือ'),
                                accessor: "mobile_number",
                                filterMethod: (filter, row) => {
                                  return row.mobile_number.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                                }
                              },
                              {
                                Header: Lg.ts('เบอร์ผิด'),
                                accessor: "status_mobile_invalid",
                                filterMethod: (filter, row) => {
                                  return row.status_mobile_invalid.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                                }
                              },
                              {
                                Header: Lg.ts('จำนวนเบอร์ซ้ำ'),
                                accessor: "data_duplicate_count",
                                filterMethod: (filter, row) => {
                                  return row.data_duplicate_count.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                                }
                              },
                              {
                                Header: Lg.ts('ข้อความ'),
                                accessor: "message",
                                filterMethod: (filter, row) => {
                                  return row.message.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                                }
                              },
                              {
                                Header: Lg.ts('ภาษาของข้อความ'),
                                accessor: "message_lenguage",
                                filterMethod: (filter, row) => {
                                  return row.message_lenguage.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                                }
                              },
                              {
                                Header: Lg.ts('เครดิตต่อ msg'),
                                accessor: "credit_per_msg",
                                filterMethod: (filter, row) => {
                                  return row.credit_per_msg.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                                }
                              },
                              {
                                Header: Lg.ts('จำนวนอักษร'),
                                accessor: "message_length",
                                filterMethod: (filter, row) => {
                                  return row.message_length.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                                }
                              },
                              {
                                Header: Lg.ts('ตั้งเวลาส่ง'),
                                accessor: "send_sms_date",
                                sortable: false,
                                filterable: false,
                                filterMethod: (filter, row) => {
                                  return row.send_sms_date.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                                }
                              }
                            ]}
                            defaultPageSize={10}
                            showPaginationTop
                            showPaginationBottom={false}
                          />
                        </GridItem>
                        : null
                    }
                  </GridContainer>
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <Dialog
          open={this.state.statusDialogOpen}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title">
            {Lg.ts("เลือก Theme SMS")}
          </DialogTitle>
          <DialogContent dividers={true}>
            <DialogContentText
              id="scroll-dialog-description"
              tabIndex={-1}
            >
              {
                (this.state.listsThemeSMSRaw.length > 0) ?
                  <List>
                    {this.state.listsThemeSMSRaw.map((row) => (
                      <ListItem
                        button
                        onClick={(e) => this.handleListItemClickSMS(row)}
                        key={row.theme_name}
                      >
                        <ListItemText primary={row.theme_name} />
                      </ListItem>
                    ))}
                  </List>
                  : null
              }

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={e => { this.handleDialogClose() }} color="primary">
              {Lg.ts("Cancel")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}
function mapStateToProps({ listsUserFromImport, listsThemeSMS }) {
  return {
    listsUserFromImport: listsUserFromImport,
    listsThemeSMS: listsThemeSMS,
  }
}

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    { listsUserFromImportUpdate, listsThemeSMSUpdate }
  )
)(ProjectCreateAndEditManagement)
